import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import LoadingState from 'components/core/loading_state'
import {
  eventTypeSelector,
  fetchGroupMemberships,
  isUserGroupsLoadedSelector,
  isUserGroupsLoadingSelector,
  resetState,
  userGroupMembershipsSelector
} from 'features/managed_event_types'

import { GroupsTable } from './groups_table'

export const OrganizationGroups = () => {
  const dispatch = useDispatch()

  const { id } = useSelector(eventTypeSelector)
  const isLoading = useSelector(isUserGroupsLoadingSelector)
  const isLoaded = useSelector(isUserGroupsLoadedSelector)
  const userGroupMemberships = useSelector(userGroupMembershipsSelector)

  useEffect(() => {
    dispatch(fetchGroupMemberships(id))

    return () => dispatch(resetState())
  }, [dispatch, id])

  if (isLoading) {
    return <LoadingState />
  }

  return (
    isLoaded && userGroupMemberships.length > 0 && <GroupsTable />
  )
}
